module.exports = __webpack_public_path__ + "static/media/startup.b6298cf6.jpg";